import frustumCull from '../frustumCull'
import hsv_rgb from '../hsv_rgb'
import noise3D from '../noise3D'

export default `${noise3D + hsv_rgb}
uniform vec3 uColor1;
uniform vec3 uColor2;
uniform vec4 uRectData;

varying vec2 vUv;
varying vec3 vNormal;
varying vec3 vNormal2;
varying vec3 vPosition;

float getFresnel(vec3 normal, float power) {
  vec3 viewDir = vec3(0.0, -0.5, 1.0);
  return 1.0 - pow(max(dot(viewDir, normal), 0.0), power);
}

void main(){
  vec3 color = vNormal2 * 0.5 + 0.5;

  #ifdef HEAD
    float n = snoise(vNormal2 * 0.2) * 0.5 + 0.5;

    float fresnel = 1.0 - getFresnel(vNormal, 2.0);
    color = mix(uColor1, uColor2, fresnel);
    color = mix(color, uColor2, n * 0.7);
  #endif

  #ifdef FACE
    float fresnel = 1.0 - getFresnel(vNormal, 4.0);
    fresnel *= 0.5;

    float l = dot(normalize(vec3(0.0, 0.5, 1.0)), vNormal2) * 0.5 + 0.5;
    l = pow(l, 5.0);
    fresnel = mix(l, fresnel * 0.6 + 0.1, smoothstep(0.0, 0.3, 1.0 - vUv.y));
    fresnel = fresnel;
    fresnel = mix(fresnel, 1.0, smoothstep(0.5, 1.0, 1.0 - vUv.y));
    fresnel = pow(fresnel, 1.2);

    color = mix(uColor1, uColor2, fresnel);
  #endif

  #ifdef MOUTH
    color = uColor1;
  #endif

  #ifdef NOSE
    float l = dot(normalize(vec3(1.0)), vNormal2);
    l = smoothstep(0.8, 1.0, l);
    color = mix(uColor1, uColor2, l);
  #endif

  #ifdef EYE
    color = uColor1;
  #endif

  #ifdef EYELID
    color = uColor1;
  #endif

  #ifdef PUPIL
    float l = dot(normalize(vec3(0.0, 0.0, 1.0)), normalize(vNormal * vec3(0.5, 1.0, 0.4))) * 0.5 + 0.5;
    l = smoothstep(0.97, 1.0, l);
    color = mix(uColor1, uColor2, l);
  #endif

  #ifdef WHISKERS
    float f = smoothstep(0.0, 2.0, abs(vPosition.x));
    color = mix(uColor1, uColor2, f);
  #endif

  #ifdef EAR
    float f = smoothstep(0.1, 0.5, (0.5 - abs(vUv.x - 0.5)) + (1.0 - vUv.y));
    f = mix(f, 0.0, smoothstep(0.1, 0.9, vUv.y));
    color = mix(uColor1, uColor2, f);
  #endif

  ${frustumCull}

  color = pow(color, vec3(1.0/2.2));
  gl_FragColor = vec4(color, 1.0);
}
`
